module.exports = __webpack_public_path__ + "media/images/icare-logo@2x-32928e5453a5da038cf224cbf046a3c7.webp";